module.exports = __webpack_public_path__ + "static/media/discrd_logo.87c33435.svg";